const finiteAmount = (value) => (
  value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value))
    ? Number(value)
    : null
);

export const normalizeEurTryRate = (value) => {
  const rate = typeof value === 'number' && Number.isFinite(value) ? value : null;
  const scaledRate = Math.round(rate * 10000);
  return rate > 0 && Number.isSafeInteger(scaledRate) && scaledRate > 0 ? rate : null;
};

const scaledCredit = (creditTry) => {
  const value = Math.round(Math.abs(creditTry) * 100) * 100;
  return Number.isSafeInteger(value) ? value : null;
};

export const getCreditCurrency = (userInfo, isReseller = false) => {
  const user = userInfo?.user || userInfo?.account_data?.user || userInfo?.user_info || {};
  return {
    currency: isReseller ? 'TRY' : ['TRY', 'EUR'].includes(user.credit_currency) ? user.credit_currency : null,
    eurTryRate: user.credit_conversion_ready === false ? null : normalizeEurTryRate(user.eur_try_rate),
  };
};

export const toDisplayCredit = (creditTry, currency, eurTryRate) => {
  const credit = finiteAmount(creditTry);
  if (credit === null) return null;
  if (currency === 'TRY') return credit;
  const rate = normalizeEurTryRate(eurTryRate);
  const creditUnits = scaledCredit(credit);
  if (currency !== 'EUR' || !rate || creditUnits === null) return null;
  return Math.sign(credit) * Math.floor(creditUnits / Math.round(rate * 10000));
};

export const formatCreditAmount = (creditTry, currency, eurTryRate, options) => {
  const amount = toDisplayCredit(creditTry, currency, eurTryRate);
  return amount === null ? '\u2014' : `${amount.toLocaleString('tr-TR', options)} ${currency === 'EUR' ? '\u20ac' : 'TL'}`;
};

export const packageCostTry = (nativePrice, currency, eurTryRate) => {
  const price = finiteAmount(nativePrice);
  if (price === null || price < 0) return null;
  if (currency === 'TRY') return price;
  const rate = normalizeEurTryRate(eurTryRate);
  if (currency !== 'EUR' || !rate) return null;
  // users.kredi stores whole TRY; match the server quote before comparing balances.
  const scaledCost = price * Math.round(rate * 10000) + 5000;
  return Number.isSafeInteger(scaledCost) ? Math.floor(scaledCost / 10000) : null;
};

export const formatCreditShortfall = (shortfallTry, currency, eurTryRate) => {
  const shortfall = finiteAmount(shortfallTry);
  if (shortfall === null) return '\u2014';
  if (currency === 'TRY') return formatCreditAmount(shortfall, currency, null, { maximumFractionDigits: 0 });
  const rate = normalizeEurTryRate(eurTryRate);
  const shortfallUnits = scaledCredit(Math.max(0, shortfall));
  if (currency !== 'EUR' || !rate || shortfallUnits === null) return '\u2014';
  return `${Math.ceil(shortfallUnits / Math.round(rate * 10000)).toLocaleString('tr-TR')} \u20ac`;
};
